<template>
  <div class="filter-set">
    <div 
      v-for="(type,index) of list"
      :key="index"
      :class="['sp-row',{'style-block-item': type.ui_cfg_block_item}]"
      >
      <h5 class="b sp-tag-name">
        {{lg('',type.type_name)}}
      </h5>
      
      <div :class="['sp-items']">
        <label v-if="!type.ui_cfg_hide_item_defaulte" class="d-block">
          <input 
            type="radio" 
            class="mr-1"
            v-model="form[type.id]"
            :value="''"
            >
          <span>
            {{lg('',{
              en: 'All',
              zh: '全部',
            })}}
          </span>
        </label>
        <label
          v-for="item of type.items"
          :key="item.id"
          class="d-block"
          >
          <input 
            type="radio" 
            class="mr-1"
            v-model="form[type.id]"
            :value="item.id"
            >
          <span>
            {{lg('',item.name)}}
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import data_filter_set from './data_filter_set.js'
export default {
  name: 'filterSet',
  components: {},
  props: [
    // ui loop
    'data_ui',

    // bind
    'form',
  ],
  data() {
    return {
      list: this.data_ui || data_filter_set,
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .filter-set{
    .sp-row{
      &.style-block-item{
        .sp-items{
          display: flex;
          justify-content: space-between;
          label{
            display: block;
            input{
              display: none;

              &:checked{
                &~span{
                  border-color: mix(#fff,$c, 50);
                }
              }
            }
            span{
              display: block;
              border: 2px solid rgba(120,120,120,0.3);
              border-radius: 4px;
              padding: 0  10px;
              user-select: none;
            }
          }
        }
      }
    }
  }
  @media(min-width: 788px){
    .filter-set{
      .sp-row{
        margin-bottom: 15px;
        
        &.style-block-item{
          .sp-items{
            flex-wrap: wrap;
            label{
              width: 48%;
            }
          }
        }
      }
    }
  }
  @media(max-width: 788px){
    .filter-set{

      .sp-row{
        display: flex;
        align-items: center;

        .sp-tag-name{
          width: 80px;
          font-size: 10px;
        }

        .sp-items{
          background-color: #f8f8f8;
          display: flex;
          flex: 1;
          white-space: nowrap;
          overflow: auto;

          label{
            margin-left: 15px;
          }
        }
      }

    }
  }
</style>